import { Option } from './types';

/** 核销模式 */
export const CancelVfnMode: Option[] = [
  { label: '独立核销', value: 2 },
  { label: '统一核销', value: 1 },
];

export enum CANCEL_MODE_ENUM {
  /** 统一核销 */
  unified = 1,
  /** 独立核销 */
  independent = 2,
}

/** 佣金模式 */
export enum CommissionMode {
  /** 向供方收取 */
  SUPPLY = 1,
  /** 向需方收取 */
  PURCHASE = 2,
}
/** 佣金模式 */
export const CommissionModeList: Option[] = [
  { label: '向供方收取', value: CommissionMode.SUPPLY },
  { label: '向需方收取', value: CommissionMode.PURCHASE },
];

/** 采购模式 */
export enum PurchaseMode {
  /** 自采模式 */
  SELF = 1,
  /** 统采模式 */
  UNIFIED = 2,
}

/** 采购模式 */
export const purchaseModeList: Option[] = [
  { label: '自采模式', value: PurchaseMode.SELF },
  { label: '统采模式', value: PurchaseMode.UNIFIED },
];

/** 物流模式 */
export enum DeliveryMode {
  /** 自配 */
  SELF = 0,
  /** 集配 */
  UNIFIED = 1,
}

/** 采购单审核方 */
export enum PurchaseAuditEnum {
  /** 监管方审核 */
  GOVERN = 1,
  /** 需方审核 */
  PURCHASE = 2,
  /** 关闭 */
  CLOSE = 0,
}
export const PurchaseAuditList: Option[] = [
  { label: '监管方审核', value: PurchaseAuditEnum.GOVERN },
  { label: '需方审核', value: PurchaseAuditEnum.PURCHASE },
  { label: '关闭', value: PurchaseAuditEnum.CLOSE },
];

/** 对账单审核方 */
export enum StatementAuditEnum {
  /** 监管方审核 */
  GOVERN = 1,
  /** 需方审核 */
  PURCHASE = 2,
  /** 关闭 */
  CLOSE = 0,
}
export const StatementAuditList: Option[] = [
  { label: '监管方审核', value: StatementAuditEnum.GOVERN },
  { label: '需方审核', value: StatementAuditEnum.PURCHASE },
  { label: '关闭', value: StatementAuditEnum.CLOSE },
];
/** 审核售后单 */
export enum AfterSalesEnum {
  /** 监管方审核 */
  GOVERN = 1,
  /** 需方审核 */
  PURCHASE = 2,
  /** 关闭 */
  CLOSE = 0,
}
export const AfterSalesList: Option[] = [
  { label: '监管方审核', value: AfterSalesEnum.GOVERN },
  { label: '需方审核', value: AfterSalesEnum.PURCHASE },
  { label: '关闭', value: AfterSalesEnum.CLOSE },
];

/** 租户部署方式 */
export enum TenantDeployMode {
  /** saas */
  Saas = 0,
  /** 私有化 */
  Private = 1,
}

/** 租户部署方式列表 */
export const TenantDeployModeList: Option[] = [
  { label: 'SaaS', value: TenantDeployMode.Saas },
  { label: '私有化', value: TenantDeployMode.Private },
];

export enum ReportAutoLockRule {
  /** 发货后锁定 */
  AFTER_SHIPMENT = 1,
  /** 收货后锁定 */
  AFTER_RECEIPT = 2,
  /** 对账后锁定 */
  AFTER_RECONCILIATION = 3,
}
/** 质检报告锁定规则 */
export const ReportAutoLockRuleOpts: Option[] = [
  { label: '发货后锁定', value: ReportAutoLockRule.AFTER_SHIPMENT },
  { label: '收货后锁定', value: ReportAutoLockRule.AFTER_RECEIPT },
  { label: '对账后锁定', value: ReportAutoLockRule.AFTER_RECONCILIATION },
];
